// ----------------------------------------------------------------------------
// Snippet: Power Tools Filter
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';


//Power Tools Filter popup on mobile
$('body, html').on('click', '.filter-menu__popup__close', function(e){
    e.preventDefault();
    $('.filter-menu__popup').removeClass('active');
    $('body').removeClass('fixedHeight filter--active');
})

$('body, html').on('click', '.filter-menu__popup__trigger', function(e){
    e.preventDefault();
    $('.filter-menu__popup').addClass('active');
    $('body').addClass('fixedHeight filter--active');
})

//Remove Fit Cards if filter is active
addEventListener("DOMContentLoaded", (event) => {
    const activeFilters = document.querySelectorAll(".filter-group:not(.filter-group-not-shown) .collection-container.active.selected");
    const fitCardsContainer = document.querySelector(".fit-cards__container");
    if (activeFilters.length > 0 && fitCardsContainer) {
        fitCardsContainer.remove();
    }
});